import { render } from "./AlertDestinationsEditor.vue?vue&type=template&id=17e5ff5f"
import script from "./AlertDestinationsEditor.vue?vue&type=script&lang=js"
export * from "./AlertDestinationsEditor.vue?vue&type=script&lang=js"

import exportComponent from "/Users/linuxbasic/GitProjects/caru-platform-api/systems/caru-cloud-platform/ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__